const getFieldConfig = (isShowBlankCol) => {
  return {
    labelSpanConfig: {
      span: 8,
      spanMd: isShowBlankCol ? 7 : 9,
    },
    valueSpanConfig: {
      span: 4,
      spanMd: 3,
    },
  };
};

export default getFieldConfig;
